import { Routes } from '@angular/router';
import { SecurityLoaders } from '@cfg/security/loaders';
import { ComponentsComponent } from './bulk-load/pages/components/components.component';
import { BulkRiskReportComponent } from './bulk-load/pages/bulk-risk-report/bulk-risk-report.component';
import { AccessDeniedComponent } from './shared/pages/access-denied/access-denied.component';
/**
 * Rutas de la aplicación
 */
export const APP_ROUTES: Routes = [
  {
    path: '',
    title: 'Carga Masiva',
    canActivate: SecurityLoaders.loadGuards(),
    component: ComponentsComponent
  },
  {
    path: 'reporte',
    title: 'Reporte Carga Masiva',
    canActivate: SecurityLoaders.loadGuards(),
    component: BulkRiskReportComponent
  },
  {
    path: 'access-denied',
    title: 'Acceso Denegado',
    component: AccessDeniedComponent
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
